import React, { useState, useEffect, useRef } from 'react';

/**
 * HOC that wraps TopBarEnvironmentIndicator to inject auth selectors.
 * Polls auth state to re-render when user role and environment become available.
 */
const TopBarEnvironmentIndicatorWrapper = (Original, system) => {
  const Wrapper = (props) => {
    const { pagoAuth2Selectors } = system;
    const [authState, setAuthState] = useState(() => ({
      role: pagoAuth2Selectors?.selectUserRole?.() || null,
      env: pagoAuth2Selectors?.selectUserEnvironment?.() || null,
    }));
    const intervalRef = useRef(null);

    useEffect(() => {
      intervalRef.current = setInterval(() => {
        const currentRole = pagoAuth2Selectors?.selectUserRole?.();
        const currentEnv = pagoAuth2Selectors?.selectUserEnvironment?.();
        if (currentRole) {
          setAuthState({ role: currentRole, env: currentEnv });
          clearInterval(intervalRef.current);
        }
      }, 200);

      return () => clearInterval(intervalRef.current);
    }, []);

    return <Original {...props} pagoAuth2Selectors={pagoAuth2Selectors} userRole={authState.role} userEnvironmentResolved={authState.env} />;
  };

  return Wrapper;
};

export default TopBarEnvironmentIndicatorWrapper;
